// Feature flags. Lesson Present mode is hidden (not deleted) for now: flip this
// to true to restore the Present button and the full-screen takeover.
export const LESSON_PRESENT_MODE_ENABLED = false;

// Returns the handler for LessonPlanWorkspace's `onPresent` prop, or undefined
// (which makes the workspace render no Present button) when the flag is off or
// the viewer is not a teacher.
export const resolveLessonPresentHandler = ({ enabled, isTeacher, enter }) =>
  enabled && isTeacher ? enter : undefined;
